
/* styles */
require("!!../../../../extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../../vue-loader/lib/style-rewriter?id=data-v-ed29e824&scoped=true!../../../../vue-loader/lib/selector?type=styles&index=0!./HollowDotsSpinner.vue")

var Component = require("!../../../../vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../vue-loader/lib/selector?type=script&index=0!./HollowDotsSpinner.vue"),
  /* template */
  require("!!../../../../vue-loader/lib/template-compiler?id=data-v-ed29e824!../../../../vue-loader/lib/selector?type=template&index=0!./HollowDotsSpinner.vue"),
  /* scopeId */
  "data-v-ed29e824",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/epic-spinners/src/components/lib/HollowDotsSpinner.vue
// module id = 865
// module chunks = 1